








import Vue from 'vue'

export default Vue.extend({
  name: 'ExpandableCheckbox',
  props: {
    shortLabel: {
      type: String,
    },
    longLabel: {
      type: String,
    },
  },
  computed: {
    label: function (): string {
      if (this.expanded) {
        return this.longLabel
      }

      return this.shortLabel
    },
  },
  data: () => ({
    expanded: false,
  }),
})
